const en = {
  appName: "Socialbility",
  welcome: "Welcome",
  continue: "Continue",
  default: "Default (Paragraph Small Regular Text)",
  h1Large: "H1 Large Text",
  h1Medium: "H1 Medium Text",
  h1Small: "H1 Small Text",
  h1XSmallExtraBold: "H1 XSmall Extra Bold Text",
  h1XSmallBold: "H1 XSmall Bold Text",
  h2LargeBold: "H2 Large Bold Text",
  h2LargeSemiBold: "H2 Large SemiBold Text",
  h2MediumBold: "H2 Medium Bold Text",
  h2MediumSemiBold: "H2 Medium SemiBold Text",
  h2SmallBold: "H2 Small Bold Text",
  h2SmallSemiBold: "H2 Small SemiBold Text",
  h3Large: "H3 Large Text",
  h3Small: "H3 Small Text",
  h3XSmall: "H3 XSmall Text",
  h4Large: "H4 Large Text",
  h4SmallSemiBold: "H4 Small SemiBold Text",
  h4SmallMedium: "H4 Small Medium Text",
  paragraphXSmallMedium: "Paragraph XSmall Medium Text",
  paragraphSmallRegular: "Paragraph Small Regular Text",
  paragraphSmallMedium: "Paragraph Small Medium Text",
  paragraphMediumRegular: "Paragraph Medium Regular Text",
  paragraphMediumSemiBold: "Paragraph Medium SemiBold Text",
  loginOrCreateAccount: "Log in or Create Account",
  or: "or",
  continueWithGoogle: "Continue with Google",
  continueWithFacebook: "Continue with Facebook",
  continueWithApple: "Continue with Apple",
  continueWithMicrosoft: "Continue with Microsoft",
  login: "Log in",
  loginNavbar: "Login",
  forgotYourPassword: "Forgot your password?",
  alreadyHaveAnAccount: "Already have an account?",
  createAccount: "Create account",
  yourPasswordShouldContain: "Your password should contain:",
  atleast6Characters: "At least 6 characters",
  atleast1NumberOrUppercaseLetter: "1 symbol or number",
  agreeAndContinue: "Agree and continue",
  saveAndContinue: "Save and continue",
  howWillYouUseSociability: "How will you use Sociability?",
  helpUsImproveYourExperience: "Help us improve your experience",
  chooseOne: "Choose one",
  back: "Back",
  howDidYouFindOutAboutSociability: "How did you find out about Sociability?",
  selectAllThatApply: "Select all that apply.",
  createYourAccessibilityProfile: "Create your accessibility profile",
  findThePlacesThatWorkForYou: "Find the places that work for you!",
  findAccessiblePlacesNearYou: "Find Accessible Places Near You",
  doYouWantToMakeYourDisabilityVisibleToTheSociabilityCommunity:
    "Would you like to show other Sociability users your accessibility needs?",
  makeDisabilityVisible: "Make disability visible?",
  youCanChangeThisAnytimeInYourAccountSettings:
    "You can change this anytime in your account settings",
  whatAccessibilityFeaturesDoYouRequire:
    "What accessibility features do you prefer?",
  areAnyOfTheseSuitable: "Are any of these suitable?",
  letsVerifyYourEmailAddress: "Let's verify your email address",
  weJustNeedToCheckTtsReallyYou: "We just need to check it's really you:",
  wehaveJustSentAnEmailTo: "We've just sent an email to:",
  clickTheLinkInsideToLogInToSociability:
    "Check your inbox for the verification email to continue",
  returnToLoginPage: "Log in to Sociability",
  getInTouch: "Get in touch",
  letUsKnowYourFeedback: "Let us know your feedback:",
  send: "Send",
  addPhotos: "Add photos",
  addPhoto: "Add photo",
  exitMenu: "Exit menu",
  preferences: "Preferences",
  yourProfile: "Your account",
  locationPreferences: "Location preferences",
  yourAccessibilityProfile: "Your accessibility profile",
  accessibilityFeatures: "Accessibility features",
  appAccessibility: "App accessibility",
  deviceSettings: "Device settings",
  helpSupport: "Help & Support",
  howTheAppWorks: "How the app works",
  taggingInformation: "Tagging information",
  faqs: "FAQs",
  aboutSociability: "About Sociability",
  appFeedback: "App feedback",
  finePrint: "Fine print",
  privacyPolicy: "Privacy policy",
  termsOfUse: "Terms of use",
  logOut: "Log out",
  resetPassword: "Reset password",
  enterYourNewPasswordAndConfirmItBelow:
    "Enter your new password and confirm it below",
  doYouOrSomeoneYouKnowHaveAnyAccessibilityRequirements:
    "Do you or someone you know have any accessibility requirements?",
  skipForNow: "Skip for now",
  tellUsABitAboutYourself: "Tell us a bit about yourself",
  doYouOrSomeoneYouKnowExperienceOrUseAnyOfTheFollowing:
    "Do you or someone you know experience or use any of the following?",
  shareYourAccessibilityProfile: "Share your accessibility profile",
  tellTheCommunityABitMoreAboutYourself:
    "Tell the community a bit more about yourself.",
  helpOtherUsersBetterUnderstandYourReviews:
    "This helps other users find venue reviews that are most relevant to them",
  setYourPreferredFilters: "Set your preferred filters",
  selectAllThatApply2:
    "Select all that apply. Change these anytime in your user profile.",
  wouldAnyOfTheseAlsoWork: "Would any of these also work?",
  cancel: "Cancel",
  close: "Close",
  takePhoto: "Take photo",
  fromPhotos: "From photos",
  termsAndConditions: "Terms and conditions",
  byClickingAgree:
    "To use Sociability, please review and agree to our terms. These outline how the app works and how your information is handled.",
  reviewOnboarding: "Review onboarding",
  searchVenueOrLocation: "Search venue or location",
  showNearBy: "Show nearby",
  refreshMap: "Refresh map",
  searchThisArea: "Search this area",
  searchInThisArea: "Search in this area",
  searchNearStation: "Search near this station",
  searchNearAirport: "Search near this airport",
  poiUnsupportedCategory: "This place type isn't supported on Sociability yet.",
  poiUnsupportedTitle: "Unsupported place",
  poiCouldNotAdd: "Sorry, we couldn't add this place. Please try again.",
  poiNotHereTitle: "No accessibility data yet",
  poiNotHereSubtitle:
    "Share your experience to help others know what to expect.",
  poiShowMeHow: "Show me how to help",
  poiGetUpdates: "Get alerts",
  poiShareInfo: "Add info",
  poiWhatYouCanDo: "What you can do",
  poiSelectApply: "Choose how you'd like to help.",
  poiAddPhotos: "Add photos",
  poiShareExperiences: "Share experiences",
  poiFlagAlerts: "Flag accessibility alerts",
  poiReportAlert: "Report alert",
  poiSubscribeUpdates: "Subscribe for updates",
  poiContinue: "Continue",
  poiUnsupportedCardTitle: "This category isn't supported yet",
  poiUnsupportedSubtitle:
    "Sociability currently focuses on social places like caf\u00e9s, restaurants, bars and bakeries.",
  poiGotIt: "Got it",
  poiWorksBetterOnAppTitle: "This works better on the app",
  poiWorksBetterOnAppSubtitle:
    "Adding photos and reporting alerts is easiest from the Sociability app. Scan the QR code or download it below.",
  noPlacesWithDataTitle: "We haven't reached your area yet",
  noPlacesWithDataSubtitle:
    "Find places nearby to subscribe for updates or be the first to share accessibility information.",
  switchToAllPlaces: "Switch to all places",
  filters: "Filters",
  listview: "List view",
  finish: "Finish",
  venueTypes: "Venue types",
  openingHours: "Opening hours",
  search: "Search",
  clearAll: "Clear all",
  showMore: "Show more",
  showLess: "Show less",
  youAreInTaggingMode: "You're in Tagging mode!",
  taggingModeDescription1:
    "You can now only see venues without accessibility information.",
  taggingModeDescription2:
    "Continue to tag the accessibility of new venues, or return to exploring venues below.",
  gotItLetsTag: "Got it. Let's tag!",
  switchBackToExploring: "Switch back to exploring venues",

  youAreInExploregMode: "You're in Explore mode!",
  homeModeDescription1:
    "You can now only see all venues - with and without accessibility information.",
  homeModeDescription2:
    "Continue to explore new venues, or return to tagging venues below.",
  gotItLetsExplore: "Got it. Let's explore!",
  switchBackToTagging: "Switch back to tagging venues",
  accessibilityOverview: "Accessibility Overview",
  completedSections: "Completed Sections",
  addAccessibilityInfo: "Add accessibility info",
  viewAllInformation: "View All Information",
  isSomethingNotRight: "Is something not right?",
  reportAnErrorOrUpdate: "Report an error or update",
  sortBy: "Sort by",
  photos: "Photos",
  reviews: "Reviews",
  addReview: "Add review",
  addAccessibilityInformation: "Add accessibility information",
  addAReview: "Add a review",
  thisVenueIsLookingBare: "This venue is looking bare...",
  addPhotosAndTagsToShare:
    "Add photos and tags to share accessibility information with others!",
  mapperNotes: "Mapper notes",
  tellOtherMappersAbout: "Tell other mappers about your experience",
  submit: "Submit",
  leaveReview: "Leave a review",
  didThisVenueSuitYourNeeds: "Did this venue suit your accessibility needs?",
  howWasYourVisitToThisVenue: "How was your visit to this venue?",
  post: "Post",
  whatIsThisPhotoOf: "What is this photo of?",
  brieflyDescribeThisPhoto:
    "Describe this photo for those who might not be able to see it. At least 5 characters are required.",
  yes: "Yes",
  no: "No",
  describeWhatThisImageShows:
    "Describe what this image shows to help our blind users.",
  pleaseSelectOneOfTheTags: "Please select one of the tags.",
  adddMorePhotos: "Add more photos",
  upload: "Upload",
  areYouSureYouWantToRemoveThisPhotoFromYourUpload:
    "Are you sure you want to remove this photo from your upload? you will lose any alt text added.",
  removePhoto: "Remove photo?",
  wereSorryThisVenueHasNoReviews:
    "We're sorry! This venue has no reviews yet. Get us started by adding one now!",
  photosUploadedSuccessfully: "Photos uploaded successfully!",
  reviewUploadedSuccessfully: "Review uploaded successfully!",
  startTagging: "Let's start tagging!",
  pickACategory:
    "Provide accessibility information by uploading photos and answering a few questions.",
  finishTagging: "Finish tagging",
  pickAnAreaToTag: "Select an area",
  pickAnAreaToTagLong:
    "Pick an area of the venue to tag! You’ll need to start with the Main Entrance, but after that you can return to choose any of the others.",
  locked: "Locked",
  editInformation: "Edit information",
  gettingStarted: "Getting started",
  dontShowThisAgain: "Don't show this to me again",
  uploadPhotosFromYourGallery:
    "Upload photos from your gallery or take new ones right now.",
  uploadPhotos: "Upload photos",
  thenAddShortDescription:
    "Then add a short description of each photo for screen reader users.",
  describeThisPhoto: "Describe this photo",
  brieflyDescribeThisPhotoYouHaveAdded:
    "Briefly describe each photo you have added for our low-vision or blind users.",
  thisIsAPhotoOf: "This is a photo of....",
  describeThisPhotoForOurBlindUsers: "Describe this photo",
  exit: "Exit",
  nextPhoto: "Next photo",
  photosAdded: "Photos added!",
  managePhotos: "Manage photos",
  toViewSimplyTap:
    "To view, simply tap a picture. If you want to reorder just drag the photos. Alternatively, you can add more photos if you like. You must upload at least one photo.",
  next: "Next",
  assignTags: "Assign tags",
  answerEachQuestionToTag:
    "Answer each question to add accessibility information to this venue for other users. Use your photos to help jog your memory.",
  areYouSure: "Are you sure?",
  ifYouLeaveThisScreenYouWillLose:
    "If you leave this screen you will lose your current photos. Click exit to start again or click continue to keep your current photos.",
  deletePhoto: "Delete photo",
  areYouSureYouWantToDeleteThisPhoto:
    "Are you sure you want to delete this photo? It will make changes to the venue.",
  selectAllApply: "Select all that apply",
  chooseOneAnswer: "Choose one answer",
  areYouSureYouWantToStopTagging: "Are you sure you want to stop tagging?",
  yourProgressWillBeSavedAndYouCanReturn:
    "Your progress will be saved and you can return to finish the area later.",
  pleaseCompleteAllRequiredQuestions:
    "* Please complete all required questions.",
  error: "Error",
  userNotLoggedIn: "User not logged in",
  updateTags: "Update tags",
  isThereAnythingThatNeedsToBeUpdated:
    "Is there anything that needs to be updated? Make sure all accessibility information is accurate and up-to-date.",
  editPhotos: "Edit photos",
  thanksForCheckingTags:
    "Thanks for updating your tags! Would you also like to check your photos to ensure they match?",
  ItsImportantToEnsureThatYourPhotosAreAccurate:
    "It's important to ensure that the photos match the tags so that our information is as accurate as possible for other users.",
  reviewPhotos: "Review photos",
  savePhotos: "Save photos",
  areYouSureYouWantToUpdateAccessibility:
    "Are you sure you want to update the accessibility information? it will make changes to the venue",
  photoGuide: "Photo guide",
  doYouWantToAddAddionalVSHInformation:
    "Do you want to add additional visual, sensory and hearing photos?",
  deleteInformation: "Delete information",
  save: "Save",
  photoWillBePermanentlyDeleted:
    "Photo will be permanently removed from this venue.",
  delete: "Delete",
  selectPhotos: "Select photos",
  atleastOnePhotoIsReq:
    "At least one photo is required for each area. Uncheck at least one photo to continue.",
  deletePhotos: "Delete photos",
  photosWillBePermanentlyDeleted:
    "Photo(s) will be permanently removed from this venue.",
  photosDeleted: "Photos deleted!",
  taggingInProgress: "Tagging in progress",
  thisAreaHasAlreadyBeenTagged:
    "This area has already been tagged. Add a new one!",
  editAccessibilityInformation: "Edit accessibility information",
  settings: "Settings",
  mapperNoteAdded: "Mapper note added!",
  noPhotosHaveBeenAddedToThisVenueYet:
    "No photos have been added to this venue yet. Get us started by adding some now!",
  thereAreCurrentlyNoImagesForVSH:
    "There are currently no images for the Visual, Sensory, and Hearing section. Add some photos or click save to finish editing.",
  thisAreaIsLocked: "This area is locked!",
  reviewSavedSuccessfully: "Review saved successfully",
  addImage: "Add image",
  inviteYourFriendsToJoinYourTeam:
    "Invite your friends to join your team and compete against others to tag the most venues!",
  myTeams: "My teams",
  shareInviteFriends: "Share & invite friends",
  shareTheSociabilityApp: "Share the Sociability App",
  askYourFriendToScan:
    "Ask your friend to scan this QR code or share via email or text",
  shareViaEmailOrText: "Share a link",
  shareUserProfile: "Share your user profile",
  inviteYourFriendsToJoinYourTeam2: "Invite friends to join your team",
  selectATeam: "Select a team",
  createTeam: "Create team",
  yourTeamName: "Your team name",
  enterYourTeamName: "Enter your team name",
  create: "Create",
  teamMembers: "Team members",
  addNewMember: "Add new member",
  noTeamMembers: "No team members",
  addNewMembersToYourTeamBy: "Add new member to your team",
  renameTeam: "Rename team",
  updateCoverPhoto: "Update cover photo",
  deleteTeam: "Delete team",
  areYouSureYouWantToDeleteThisTeam:
    "Are you sure you want to delete this team?",
  addTeamMember: "Add team member",
  askYourFriendToScanThis:
    "Ask your friend to scan this QR code or send via email or text.",
  viewProfile: "View profile",
  removeUser: "Remove team member",
  teamMemberProfileSetToPrivate: "Team member profile set to private",
  removeMember: "Remove member",
  areYouSureYouWantToRemoveThisMember:
    "Are you sure you want to remove this member?",
  flagUser: "Flag user",
  blockUser: "Block user",
  reportAnIssueWithAnotherUser: "Report an issue with another user",
  desribeTheIssueWithThisUserAndAddScreenshots:
    "Describe the issue with this user and add any screenshots that might help explain your information.",
  share: "Share",
  editReview: "Edit review",
  deleteReview: "Delete review",
  aSociabilityAdminHasEditedTheseTags:
    "These tags have been updated by a Sociability Admin.",
  continueTaggingQuestion: "Continue tagging?",
  continueTagging: "Continue tagging",
  iWilldoItLater: "I'll do it later",
  leaveTeam: "Leave team",
  earnPointsByAddingTagsDesc:
    "Earn points by adding tags, reviews and photos for venues. Earn special badges to get an extra boost and you move up the leaderboard!",
  areYouSureYouWantToLeaveThisTeam: "Are you sure you want to leave this team",
  explore: "Explore",
  mySavedPlaces: "My saved places",
  myVenues: "My venues",
  noVenuesYet: "You don't have any venues yet",
  noVenuesYetDescription:
    "When you claim or are added to a venue, it will appear here for quick access.",
  basicInfo: "Basic Information",
  fullName: "Full name",
  edit: "Edit",
  email: "Email",
  gender: "Gender",
  yearOfBirth: "Year of birth",
  password: "Password",
  changePassword: "Change password",
  privacySettings: "Privacy settings",
  shareYourProfileActivity: "Profile activity",
  profileVisibility: "Make your profile activity visible to other users",
  makeYourDisabilityVisibleInreviews:
    "Make your disability visible in venue reviews",
  yourAccessRequirements: "Your access requirements",
  yourSavedFilters: "Your saved filters",
  updateProfile: "Update Profile",
  update: "Update",
  saveChanges: "Save changes",
  emailAndPassword: "Email & Password",
  filtersWillDisplayVenuesWithYour:
    "Filters will display venues with your preferred accessibility features.",
  account: "Account",
  accessibility: "Accessibility",
  activities: "Activities",
  comingSoon: "Coming soon",
  deleteYourAccount: "Delete your Account",
  yourAccountWillBeDeleted:
    "Your account will be deleted, this action cannot be undone.",
  chooseAGender: "Pick a gender",
  pickYearOfBirth: "Pick year of birth",
  updatePassword: "Update password",
  currentPassword: "Current password",
  newPassword: "New password",
  confirmPassword: "Confirm password",
  areYouSureYouWantToDeleteThisAccount:
    "Are you sure you want to delete this account?",
  deleteAccount: "Delete account",
  confirmProfilePhoto: "Confirm profile photo",
  enterYourExistingPwd: "Enter your existing password",
  createAStrongPwd: "Create a strong password",
  confirmYourNewPwd: "Confirm your new password",
  passwordMatches: "Passwords match",
  passwordsDontMatchPleaseTryAgain:
    "Passwords don't match, please check and try again",
  yourPwdShouldContain: "Your password should contain: ",
  atLeast6Chars: "At least 6 characters",
  oneSymbolOrNumber: "One symbol or number",
  updateEmail: "Update email",
  passwordShouldContain:
    "Password should contain at least 6 characters, one symbol or number",
  closedToday: "Closed Today",
  temporarilyClosed: "Temporarily closed",
  invalidTime: "Invalid Time",
  accessibilityInformationAvailable: "Accessibility information available",
  noAccessibilityInformationAvailable: "No accessibility information available",
  lastUpdated: "Last updated",
  allPhotos: "All photos",
  allReviews: "All reviews",
  makeYourDisabilityPublic: "Make your disability public?",
  youCanChangeThisAnytimeInYourUserProfile:
    "You can change this anytime in your user profile.",
  bySelectingAgreeAndContinue:
    "I confirm that I have read, understood and accept the",
  and: "and",
  privacyNotice: "privacy notice",
  loading: "Loading...",
  downloadApp: "Download App",
  searchForVenue: "Search for a venue",
  typeAVenueNameOrLocation: "Type a venue name or location",
  yourActivity: "Your activity",
  applySavedAccessibilityFilters: "Apply saved accessibility filters",
  applyFilters: "Apply filters",
  openNow: "Open now",
  signInWithApple: "Sign in with Apple",
  teamNameLengthError: "Team name must have at least 3 characters",
  allSavedPlaces: "All saved places",
  deleteThisList: "Delete this list?",
  deleteListMessage:
    "This list and all its venues will be removed from your saved places. This action cannot be undone.",
  willBePermanentlyDeletedFromSavedPlaces:
    "will be permanently deleted from your saved places.",
  sort: "Sort",
  deleteFromList: "Delete from list?",
  areYouSureYouWantToDeleteThisFromList:
    "Are you sure you want to delete this place from your list? It will also be deleted from the All Saved Places list.",
  done: "Done",
  youHaventSearchedForAnyPlacseYet: "You haven’t saved any places yet",
  clickOnTheHeartIcon:
    "Click on the heart icon when viewing a place to save it to a list.",
  startANewSearch: "Start a new search",
  createList: "Create list",
  yourListName: "Your list name",
  enterYourListName: "List name",
  addedToYourSavedPlaces: "New list has been added",
  addToSavedPlaces: "Add to saved places",
  createANewList: "Create a new list",
  pleaseSelectAList: "Please select a list",
  weHaventReachedYourAreaYet: "We haven't reached your area yet",
  exploreOrUncoverMore:
    "Explore cities we already support, or uncover more places by sharing accessibility information to grow the map together.",
  uncoverMore: "Search for another venue",
  viewAvailablePlaces: "See nearest venues",
  switchToAllPlaces: "Switch to all places",
  nearbySubscribeOrShare:
    "Find places nearby to subscribe for updates or be the first to share your accessibility experience",
  bitLostMessageSearch:
    "Looks like we’re a bit lost! Try tweaking your search by adding in more details about the venue name, type or address you’re looking for",
  noMatches: "No matches",
  tryUpdateFilters: "Try changing or removing some of your filters",
  updateFilters: "Update filters",
  ProfileAndPreferences: "Profile & preferences",
  privacy: "Privacy",
  shareYourDisability: "Help the community understand your unique perspective",
  seeAllLevelsBadges: "See all Levels & Badges",
  recentActivity: "Recent activity",
  deletedFromList: "Saved venue deleted from list",
  listCoverPhotoUpdated: "List cover photo updated",
  renameSavedList: "Rename list",
  rename: "Rename",
  listRenamed: "List renamed",
  forgotPassword: "Forgot password",
  updateAccessibilityFilters: "Update accessibility filters",
  profileAcessibilityUpdated: "Profile acessibility have been updated.",
  areYouSureYouWantToDeleteInformationTagging:
    "Are you sure you want to delete information for this area? Information will be deleted permanently.",
  deleteArea: "Delete area",
  shareVenue: "Share venue",
  downloadTheSociabilityApp: "Download the Sociability app!",
  helloCheckOutSociability:
    "Hello! Check out Sociability - a great app I use to find accessible places",
  seeThisSociabilityVenue: "See this Sociability venue!",
  helloCheckoutThisVenue: "Hello! Check out this venue on Sociability",
  shareInviteTeamMemberTitle: "Join my Sociability team!",
  shareInviteTeamMemberMsg: "Hello! Join my team on Sociability",
  shareUserProfileTitle: "See my Sociability profile!",
  shareUserProfileMessage: "Hello! Check out my profile on Sociability",
  shareSavedListTitle: "See my favourite Sociability places!",
  shareSavedListMessage: "Hello! Check out my favourite places on Sociability",
  noActivityFound: "No activity found",
  bitLostMessageActivity:
    "Looks like we're a bit lost! Try tweaking your search by adding in more details about the venue name, type or address you’re looking for",
  chooseADifferentPhoto: "Choose a different photo",
  editProfilePhoto: "Edit profile photo",
  logOut: "Log out",
  areYouSureYouWishToLogOut: "Are you sure you wish to log out?",
  viewVenues: "View Venue",
  venueAlreadySaved: "Venue already saved",
  joinTeam: "Join team",
  areYouSureYouWantToJoinThisTeam: "Are you sure you want to join this team?",
  pleaseLoginToJoinTeam: "Please login to join a team",
  passwordAtLeast6Chars: "At least 6 characters",
  passwordOneSymbolOrNumber: "One symbol or number",
  mapView: "Map view",
  changesSaved: "Changes saved",
  listView: "List view",
  fullPage: "Full page",
  noSavedFiltersFound: "No saved filters found!",
  activityView: "My Activity",
  add: "Add",
  resolveNote: "Resolve Note",
  beforeYouUseSociability: "Before you start",
  checkOutWhatsNearYou: "Check out what's near you!",
  turnOnLocationTrackingHeader:
    "Discover new places, events, and services around you. Enable location tracking to get the most out of your experience.",
  toLetUsLocateYou:
    "To let us locate you on our map and show you nearby places",
  accessToLocationWasDenied:
    "To use this feature, please grant Sociability access to your location!",
  locationDenied: "Location Denied",
  locationPermissionGranted: "Location permission granted",
  locationPermissionDenied: "Location permission denied",
  errorLoadingCity: "Error loading city",
  describeYourVisitToThisVenue: "Please describe your visit to this venue",
  saved: "Saved",
  mustBeLoggedInToSubmitReview: "Must be logged in to submit review",
  yourLocation: "Your Location",
  updateYourDeviceSettings: "Update your device settings",
  allowAccessToCamera: "Allow access to camera",
  allowAccessToPhotos: "Allow access to photos",
  locationTrackingText:
    "To let us locate you on our map and show you nearby places",
  cameraAccessText:
    "So you can take photos when adding accessibility information to venues",
  photosAccessText:
    "So you can attach photos when adding accessibility information to venues",
  camera: "Camera",
  accessToCameraWasDenied:
    "To use this feature, please grant Sociability access to your camera!",
  accessToPhotosWasDenied:
    "To use this feature, please grant Sociability access to your photos!",
  seeMyFavSociabilityPlacesTitle: "See my favourite Sociability places!",
  seeMyFavSociabilityPlacesText:
    "Hello! Check out my favourite places on Sociability",
  seeThisSociabilityVenueTitle: "See this Sociability venue!",
  seeThisSociabilityVenueText: "Hello! Check out this venue on Sociability",
  darkMode: "Dark mode",
  chooseColorMode: "Choose color mode",
  theme: "Theme",
  appAccessibilityTopText:
    "Choose whether to use your device's accessibility settings or customize them specifically for this app. Toggle the switch below to apply app-specific accessibility settings",
  locationSettingsRequired: "Location settings required",
  locationSettingsRequiredText:
    "Please enable your browser’s location settings to find accessible places near you!",
  locationSettingsRequiredMessage:
    "Please enable location services to search nearby",
  spottedSomethingWrong: "Spotted something wrong?",
  tellUsWhatInformationNeedsUpdating: "Tell us what information needs updating",
  moreDetailTheBetter: "The more detail the better",
  helpUsCatchEveryError: "Help us catch every error!",
  isThereAnyIncorrectInformationProvided:
    "Is there any incorrect information provided in this review?",
  tellUsWhichTagsAreIncorrect: "Tell us which tags are incorrect",
  tellUsWhyThisPhotoIsIncorrect: "Tell us why this photo is incorrect",
  pleaseClickTaggingTitle:
    "Please click on the boxes below to see detailed content",
  getInTouchPlaceholderText:
    "Please describe the issue you’re having or any feedback you’d like to share...",
  flagIncorrectInformation: "Flag incorrect information",
  tellUsaBitMoreAboutYourself: "Tell us a bit more about yourself",
  addNote: "Add alert",
  leaveANoteAboutThisVenue: "Leave a note about this venue",
  characters: "characters",
  verifyThanksMessage:
    "Thanks for verifying! You're now ready to start finding accessible places.",
  noPageFound: "Well this is awkward 😬",
  bitLostMessagePage:
    "The page you are looking for doesn't exist or has been moved. Please go back to the homepage.",
  gotoHomePage: "Go to homepage",
  enterPasswordBelow:
    "Enter your password below to start finding accessible places",
  passwordProtectedPage: "Private Viewing",
  enterPasswordToView: "Please enter the password to access this resource",
  enterPassword: "Enter password",
  incorrectPassword: "Incorrect password, please try again.",
  unlock: "Unlock",
  redirectingToLogin: "Redirecting to login...",
  thanksForEmail:
    "Thanks for your email, please provide more information for: ",
  weCanHelp: "It's okay! We can Help!",
  enterEmailBelowForgot:
    "Enter your email address below and we’ll get you and email to reset your password.",
  profileSetup: "Profile Setup",
  welcomeToSociability: "Welcome to Sociability",
  yourIntroductionToSociability: "Your introduction to Sociability",
  tellUsHowYouFoundUs: "Tell us more about how you found us",
  appPermissions: "App Permissions",
  updateYourPermissionsToImproveText:
    "Update your permissions to improve your experience using the Sociability App.",
  flagIncorrectPhoto: "Flag incorrect photo",
  milesAway: "miles away",
  photoDescription: "Photo Description",
  returnToApp: "Log in to Sociability",
  locationSettings: "Location Settings",
  exploreYourLocalArea: "Explore your local area",
  turnOnLocationTracking: "Turn on location tracking",
  locationText:
    "Please click continue to open your location settings. Turning on your location will allow us to show your location on the map, and to show you nearby venues that meet your accessibility needs! You can always update your settings in the future.",
  updatedBySociability: "Updated by Sociability",
  mapperEditedHeader:
    "Our mapping team has updated the details for this venue. You can no longer edit your tags.",
  reportMapperTags:
    "You can still let us know if there has been any recent changes by clicking the button below",
  reportARecentChange: "Report a recent change",
  loggedInSuccessfully: "Successfully logged in",
  categoryNotFound: "Category not found",
  pleaseSelectATeamToShare: "Please select a team to share",
  openEmailApp: "Open email app",
  openLocationSettings: "Open location settings",
  openSettings: "Open Settings",
  yourAccessibilityProfileCaps: "Your Accessibility Profile",
  personaliseYourExp:
    "Personalise your experience and join the Sociability community.",
  loginToCustomizeExperience:
    "Log in to customise your experience. You can update your profile, set accessibility preferences, and control your privacy and notifications. ",
  mySavedPlacesCaps: "My Saved Places",
  startBuildingSpots:
    "Start building your collection of favourite accessible spots!",
  startBuildingSpots2:
    "By logging in, you can start saving and organising your favourite accessible spots. Build a list tailored to your needs and preferences.",
  loginToStart: "Login to start",
  venueDetails: "Venue Details",
  chooseSection: "Choose a section",
  sections: "Sections",
  areas: "Areas",
  previousPhoto: "Previous Photo",
  atLeast5CharactersRequired:
    "At least 5 characters required for photo description",
  atLeast3CharactersRequired: "At least 3 characters required for list name",
  verifyEmailAddress: "Verify Email Address",
  ok: "Ok",
  tagging: "Tagging",
  exploreYourFavoriteAccessibleSpots:
    "Explore your favourite accessible spots, create new lists or add new discoveries.",
  yourCuratedCollection: "Your curated collection of accessible places",
  reviewMustBeAtLeast5Characters: "Review must be at least 5 characters",
  helpUsImproveAccessibility: "Help us improve accessibility:",
  name: "Name",
  joinOrCreateTeam: "Join or create a team",
  inviteFriends:
    "Invite your friends and compete against others to tag and review the most venues.",
  teamName: "Team name",
  teams: "Teams",
  sendInvite: "Send invite",
  greatTeamsStartHere:
    "Great teams start here! Invite friends to join and see what you can accomplish together",
  createOrJoinTeamDetails:
    "Create or join teams to collaborate, compete, and discover more venues together.",
  teamSettings: "Team settings",
  yourFeedbackHelps: "Your feedback helps others in our community.",
  wasThisVenueAccessibleForYou: "Was this venue accessible for you?",
  describeYourExperience: "Describe your experience",
  shareYourExperience:
    "Share your experience! Your photos help others get a better sense of the venue.",
  haveYouSpottedSomethingWrong:
    "Have you spotted something wrong? Let us know below and add pictures to help us improve this venue.",
  flagVenue: "Flag venue",
  submitFlag: "Submit flag",
  flagReview: "Flag review",
  flagPhoto: "Flag photo",
  // DEV-444 — photo content-safety guardrail messages (generic on purpose).
  // Partial success renders "<savedLabel> — <dropped>" title + a <reason> line.
  photoGuardrailSavedDefault: "Saved",
  photoGuardrailReportSaved: "Report saved",
  photoGuardrailReviewSaved: "Review saved",
  photoGuardrailTagsSaved: "Tags saved",
  photoGuardrailPhotosSaved: "Photos saved",
  photoGuardrailDroppedOne: "1 photo wasn't attached",
  photoGuardrailDroppedMany: "{count} photos weren't attached",
  photoGuardrailReasonOne: "It doesn't meet our content guidelines.",
  photoGuardrailReasonMany: "They don't meet our content guidelines.",
  photoGuardrailAllRejectedOne:
    "This photo couldn't be uploaded as it doesn't meet our content guidelines.",
  photoGuardrailAllRejectedMany:
    "These photos couldn't be uploaded as they don't meet our content guidelines.",
  photoGuardrailUnavailable:
    "Photo checks are unavailable right now — please try again shortly.",
  aiValidationCouldNotGenerateAltText:
    "AI couldn't generate a reliable suggestion for this photo — please add manually.",
  aiValidationCouldNotGenerateTags:
    "AI couldn't generate reliable tag suggestions — please select tags manually.",
  savedPlacesText:
    "Tap 'Explore nearby' to find accessible places around you. When viewing a venue, use the 'Save' button to create or add it to your list.",
  exploreNearBy: "Explore nearby",
  backToVenueDetails: "Back to venue details",
  discoverMoreVenues: "Discover more venues",
  discoverMoreVenuesMessage:
    "Great start, now explore more venues to build your personal accessible guide.",
  savedPlacesListEmpty: "Your list is currently empty",
  savedPlacesListEmptyMessage:
    "Tap 'Explore nearby' to discover accessible venues. Use the 'Save' button when viewing a place to add it to this list.",
  exploreNearby: "Explore nearby",
  exploreNearbyTip:
    "Tip: Use the 'Save' button when viewing a venue to add it to your list.",
  listDescription: "Your curated collection of accessible places",
  startBuildingYourCollection:
    "Start building your collection of favourite accessible spots!",
  youHaventSearchedForAnyPlacseYetDescription:
    "Saving accessible places helps you plan outings more easily and share recommendations with friends. Create a personalised guide to your favourite accessible spots around town.",
  youNeedToLogin: "You need to login to create and view your lists",
  youNeedToLoginDescription:
    "Create personalised lists of accessible venues and share recommendations with the Sociability community. Find and save places that match your specific needs and preferences.",
  openInNewTab: "Open in new tab",
  noAccessibilityInformation: "No accessibility information",
  flagArea: "Flag Area",
  describeYourThought: "Describe your thought",
  personalDetails: "Personal details",
  loctionSettingsRequired: "Loction settings required",
  loctionSettingsRequiredMessage:
    "Please enable location services to find your location and discover",
  flagAccessibility: "Flag Accessibility",
  tellUsWhatIsIncorrect: "Tell us what's incorrect",
  yourFeedbackHelpCommunity: "Your feedback helps others in our community.",
  submitMapperNotes: "Submit Mapper Notes",
  youUseOrExperienceTheFollowing: "You use or experience the following:",
  exitApp: "Exit App",
  areYouSureYouWantToExit: "Are you sure you want to exit?",
  previous: "Previous",
  additionalAreas: "Additional Areas",
  startExploring: "Start Exploring",
  applySavedFiltersText:
    "You can quickly apply your saved filters with the toggle. Saved filters can be updated in ",
  noUserActivity:
    "This user currently has no activity or has set their profile to private.",
  noCurrentUserActivity:
    "Your adventure awaits! You don't have any recent activity yet. Start exploring to fill this page with your exciting discoveries and achievements.",
  fewSearchResults:
    "We found a few options, but there might be more. Try refining your search or adjusting your filters to discover additional venues.",
  keepExploring: "Keep exploring!",
  editFilters: "Edit filters",
  oopsNoVenuesFound: "Oops! No venues found",
  noSearchResultsHelpText:
    "We couldn't find any venues. Try checking your spelling, use alternative terms, adjusting filters, or widening your search area. ",
  onlyTeamOwnerCanChangePhoto: "Only the team owner can change the cover photo",
  reportUserBehaviour: "Report user behaviour",
  reportUserHelpText:
    "Help keep our community safe by reporting inappropriate behaviour. Our moderation team will review. ",
  reportUserHint:
    "Describe the issue with this user in detail. Include any relevant information that can help us investigate.",
  blockUserHelpText:
    "Blocking this user will prevent them from interacting with you or seeing your content. ",
  guides: "Guides",
  closeMenu: "Close menu",
  whatAccessibilityFeatures: "What accessibility features do you prefer?",
  whatAccessibilityFeaturesSelect:
    "Select all that apply. Change these anytime in your user profile",
  leave: "Leave",
  chooseAnAreaToTag:
    "Choose an area. Once the main area is completed, you can add information to other areas.",
  addANewSpace: "Add a new space",
  addANewSpaceText:
    "Create a space. Once the space is completed, you can add information to other spaces.",
  addANewSpaceDetails:
    "Get started by adding your first space. Once you create a space, you'll be able to add detailed information",
  createSpace: "Create space",
  viewSpace: "View space",
  editSpace: "Edit space",
  duplicateSpace: "Duplicate space",
  listSettings: "List settings",
  generalInfo: "General info",
  spaces: "Spaces",
  floor: "Floor",
  visibility: "Visibility",
  addTags: "Add tags",
  selectFloor: "Select floor",
  selectVisibility: "Select visibility",
  connectedSpaces: "Connected spaces",
  areYouSureYouWantToDuplicateThisSpace:
    "Are you sure you want to duplicate this space?",
  duplicate: "Duplicate",
  deleteSpace: "Delete space",
  thisSpaceWillBePermanentlyDeleted:
    "Click 'Delete' to permanently remove the space and can't be undone. Click 'Cancel' to stop this action.",
  assignTagsInfo:
    "Is there anything that needs to be updated? Make sure all the accessibility information is accurate and up-to-date.",
  visible: "Visible",
  spaceName: "Search space name",
  notes: "Notes",
  addInformation: "Add information",
  addInfo: "Add info",
  deleteSelectedPhotos: "Delete selected photos",
  areYouSureYouWantToDeleteThisSpace:
    "Are you sure you want to delete this space?",
  skipTags: "Skip tags",
  taggingFinishedText: "Great work, your photos and tags have been added.",
  whatWouldYouLikeToDoNext: "What would you like to do next?",
  taggingFinished: "Tagging finished",
  searchSpaces: "Search spaces",
  addNewSpace: "Add new space",
  duplicateSpaces: "Duplicate spaces",
  spaceNameAlreadyTaken: "Please enter a different space name",
  unsavedTags: "Unsaved tags",
  unsavedPhotos: "Unsaved photos",
  accessibilityInformation: "Accessibility information",
  youReachedLimit: "You reached the limit to duplicate at once",
  editTags: "Edit tags",
  leaveUnsavedPhotos: "Leave photo edits?",
  leaveUnsavedPhotosMessage:
    "You have unsaved changes to your photos. Click 'Leave' to exit the page and permanently delete all unsaved edits, or click 'Stay' to continue editing.",
  deleteComplexPhotoText:
    "Click 'Delete' to permanently remove this photo and can't be undone. Click 'Cancel' to stop this action.",
  clickSaveToUpdatePhotos: "Click 'Save photos' to update highlighted photos.",
  continueUnsavedEdits: "Continue unsaved edits?",
  deleteSelectedPhotosText:
    "Click 'Delete' to permanently remove the selected photos and can't be undone. Click 'Cancel' to stop this action.",
  deleteAllPhotos: "Delete all photos?",
  deleteAllPhotosText:
    "Click 'Delete' to permanently remove the all photos and restart photo upload. Click 'Cancel' to stop this action.",
  leaveUnsavedTags: "Leave tag edits?",
  leaveUnsavedTagsMessage:
    "You have unsaved changes to your tags. Click 'Leave' to exit the page and permanently delete all unsaved edits, or click 'Stay' to continue editing.",
  uploadPhotosForCurrentSpace: "Upload photos for current space",
  assignTagsForCurrentSpace: "Assign tags for current space",
  saveSpace: "Save space",
  advancedFilters: "Advanced filters",
  space: "Space",
  discardChanges: "Discard space details edits?",
  discardChangesMessage:
    "You have unsaved changes to your space details. Click 'Discard' to permanently delete all unsaved edits, or click 'Keep editing' to continue making changes.",
  discard: "Discard",
  keepEditing: "Keep editing",
  spaceDetails: "Space details",
  previousTags: "Previous tags",
  taggingStatus: "Tagging status",
  addSpaceDetails: "Add space details",
  returnOnDate: "Return on date",
  returnToVenue: "Return to venue",
  updateComplexTagsDesc:
    "Answer each question to add accessibility information to this venue for other users. Use your photos to help jog your memory. ",
  editSpaceDetails: "Edit space details",
  viewSpaceDetails: "View space details",
  leaveSpaceDetailsEdits: "Leave space details edits?",
  leaveSpaceDetailsEditsMessage:
    "You have unsaved changes to your space details. Click 'Leave' to exit the page and permanently delete all unsaved edits, or click 'Stay' to continue editing.",
  stay: "Stay",
  noSpacesFound: "No spaces found",
  noSpacesFoundText:
    "We couldn't find any spaces matching your search. Try checking your spelling, using different keywords, or adjusting your filters.",
  remarks: "Remarks",
  spaceAction: "Space action",
  saveNote: "Save note",
  shareYourInsightsToHelp: "Share your insights to help the team. ",
  selectOneThatApply: "Select one that apply",
  doesTheNoteApplyToWholeVenue: "Does the note apply to the whole venue",
  addNotesHere: "Add notes here",
  selectLocation: "Select location",
  noteLocation: "Note location",
  createNewTask: "Create new task",
  taskName: "Task name",
  applyNoteLocation: "Apply note location",
  discardNoteLocations: "Discard note locations?",
  discardNoteLocationsMessage:
    "You have unsaved changes to your note locations. Click ‘Discard’ to permanently delete all unsaved edits, or click ‘Keep editing’ to continue making changes.",
  wholeVenue: "Whole venue",
  selectNoteLocation: "Select note location",
  searchLocation: "Search location",
  searchFloors: "Search floors",
  updateNote: "Update note",
  connectedSpace: "Connected space",
  applyConnectedSpace: "Apply connected space",
  discardConnectedSpaces: "Discard connected spaces?",
  discardConnectedSpacesMessage:
    "You have unsaved changes to your connected spaces. Click ‘Discard’ to permanently delete all unsaved edits, or click ‘Keep editing’ to continue making changes.",
  noSpaces: "No spaces",
  noMatchingSpaces: "No matching spaces",
  addSpace: "Add space",
  noResultsFound: "No results found",
  noResultsFoundText:
    "We couldn't find any results matching your search. Try checking your spelling, using different keywords, or adjusting your filters.",
  newList: "New list",
  profile: "Profile",
  manageAccount: "Manage account",
  badges: "Badges",
  activity: "Activity",
  team: "Team",
  devicePermissions: "Device permissions",
  about: "About",
  whatsNew: "What's new",
  helpAndSupport: "Help and support",
  legal: "Legal",
  levelsAndBadges: "Levels & Badges",
  level: "Level",
  points: "Points",
  streak: "Streak",
  options: "Options",
  transportFitlers: "Transport filters",
  stations: "Stations",
  vehicles: "Vehicles",
  currentUserLocation: "Current user location",
  areYouSureYouWantToResolveThisNote:
    "Click ‘Resolve’ to confirm that this note is complete and remove it permanently. Click ‘Cancel’ to keep the note.",
  resolveNoteButton: "Resolve",
  mapperNote: "Mapper note",
  noteOnlyVisibleToTeam: "This note will only be visible to team",
  noteVisibleoAll: "This note will be visible to all",
  publicNote: "Alert",
  area: "Area",
  whatAreaIsTheNoteFor: "What area is the note for?",
  howEssentialIsThisNote: "How essential is this note?",
  searchNoteHeadline: "Search note headline",
  selectPriorityLevel: "Select priority level",
  scheduleDateRange: "Schedule date range",
  leaveUntilBlankToKeepPermanently: "Leave until blank to keep permanently",
  fromDate: "From date",
  toDate: "To date",
  untillDate: "Until date",
  venueNote: "Alert",
  whatIsTheStatusOrIssueWithThisVenue:
    "What is the status or issue with this venue?",
  priorityLevels: "Priority levels",
  doesTheNoteApplyToTheWholeVenue: "Does the note apply to the whole venue",
  doesTheNoteHaveAnEndDate: "Does the note have an end date?",
  shareYourInsightsToHelpMapper:
    "Share your insights to help the team. Describe any important information about the venue below.",
  dateRange: "Date range",
  noNotes: "No alerts for this venue yet",
  noNotesDescription:
    "Tap “Add alert” to be the first to share accessibility insights! Your knowledge helps others explore.",
  deleteNote: "Delete note",
  deleteNoteMessage:
    "Are you sure you want to delete this note? This action cannot be undone.",
  noteUpdatedSuccessfully: "Note updated successfully",
  noteCreatedSuccessfully: "Note created successfully",
  resolveNoteMessage: "Are you sure you want to resolve this note?",
  resolve: "Resolve",
  doYouWantToScheduleThisNote:
    "Do you want to schedule this note for specific dates?",
  noMapperNotes: "No mapper notes for this venue yet",
  noMapperNotesDescription:
    "Tap 'Add note' to record important information about the venue and keep the rest of the team up to date.",
  flagVenueNote: "Flag alert",
  flagVenueNoteMessage:
    "Have you spotted something wrong? Let us know below and add pictures to help us improve this venue.",
  selectStatus: "Select status",
  statusExplained: "Status explained",
  createNote: "Create note",
  thisWillBeOnlyVisibleToTheTeam: "This will be only visible to the team",
  thisNoteWillBeVisibleToEveryone: "This note will be visible to everyone",
  selectArea: "Select area",
  editNote: "Edit alert",
  addNoteHeadline: "Add note headline",
  noteHeadline: "Note headline",
  noteHeadlineTemplate: "Note headline template",
  addTheMissingDetails: "Add the missing details",
  preview: "Preview",
  previewNoteHeadline: "Preview note headline",
  noteValidity: "Set date",
  noteDetails: "Note details",
  viewNoteDetails: "View note details",
  levelsExplained: "Levels explained",
  location: "Location",
  noteFor: "Note for",
  addNoteHere: "Add note here",
  selectNotePriority: "Priority",
  selectNoteStatus: "Select note status",
  viewAnnouncementDetails: "View announcement details",
  announcements: "Announcements",
  announcementTitle: "Announcement",
  note: "Note",
  allNotes: "All notes",
  photo: "Photo",
  spaceList: "Space list",
  downloadPhoto: "Download photo",
  view: "View",
  selectFloors: "Select floors",
  floors: "Floors",
  apply: "Apply",
  selectAreas: "Select areas",
  noNearByVenuesInThisCategory: "No nearby venues in this category",
  tryUpdateCategoryFilters:
    "Try changing the category or click below to view all nearby venues",
  viewAllNearbyVenues: "View all",
  makeVenueVisibleToMappersUntil: "Make venue not visible to mappers until",
  searchNearbyVenues: "Search nearby venues",
  returnToVenueOnDate: "Return to venue on date",
  contactName: "Contact name",
  contactEmail: "Email",
  contactPhone: "Phone",
  claimAdded: "Claim added successfully",
  later: "Later",
  businessClaimed: "Business claimed",
  interestedInKnowingMore: "Want to know about this venue's accessibility?",
  letUsKnowIfYoudLikeToSeeMoreDetailsAboutThisVenue:
    "Click below to tell this venue that you'd like them to share accessibility information.",
  ImInterested: "I want to know!",
  yourBusiness: "Your business?",
  claimItNow: "Claim it now!",
  claimMyBusiness: "Claim my business",
  claimMyBusinessText:
    "Thank you for your interest in Sociability! Please provide more information below. Our team will reach out to you soon for further arrangements.",
  areYouSureYouWantToLeaveClaimProcess: "Leave claim process?",
  yourClaimDetailsWillBeLost:
    "Your claim details haven't been saved. Click 'Leave' to exit, or click 'Stay' to complete the process.",
  businessName: "Business name",
  howCanWeContactYou: "How can we contact you?",
  emailIsRequired: "Email is required",
  provideAtleastOneAnswer: "Provide at least one answer",
  tellUsMoreAboutVenue: "Tell us more about your venue",
  phone: "Phone",
  contactNameRequired: "Contact name is required",
  areYouBusinessOwner: "Are you the business owner ?",
  claimSubmitted: "Business claim submitted",
  claimSubmittedText:
    "Your claim has been successfully submitted! Log in or create a new account to unlock features for more accessibility information.",
  invalidEmail: "Invalid email",
  emailRequired: "Please enter email",
  submitInterest: "Submit interest",
  wouldYouOrSomeoneYouKnowLikeToLearnMoreAboutAccessibilityInformationFor:
    "Would you or someone you know like to learn more about accessibility information for",
  thanksForYourFeedback: "Thanks for letting us know!",
  yourInputHelpsIndicateInterestInThisVenue:
    "We'll do our best to get this for you ASAP!",
  interestThankyouMessageWithCreateAccount:
    "We'll do our best to get this for you ASAP! Log in or create a new account to unlock features for more accessibility information.",
  interestReceived: "Interest received",
  areYouTheBusinessOwner: "Are you the business owner ?",
  yesThisIsMyBusiness: "Yes, this is my business",
  photoGallery: "Photo gallery",
  bySociability: "Walk-through",
  byUsers: "By Users",
  logoutConfirmation: "Are you sure you want to logout?",
  turnOn: "Turn on",
  nearBy: "Nearby",
  loremIpsum:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum",
  loginToViewList:
    "Log in to save venues, get instant alerts and share your experiences with the community.",
  searchAreaOrCity: "Search area or city",
  currentLocation: "Current location",
  oxfordCircusLondon: "Oxford circus, London",
  defaultLocationOxfordCircus: "Oxford circus, London (Default)",
  clearLocation: "Clear location",
  setLocationOnMap: "Set location on map",
  popularCities: "Popular cities",
  dragThePinOnTheMapToGetTheGeolocation:
    "Drag the pin on the map to get the geolocation.",
  setPhotoOrder: "Set photo order",
  numberAllPhotosBeforeContinuing: "Number all photos before continuing.",
  selectReturnDate: "Select return date",
  selectActionDate: "Select action date",
  editUploadedPhotos: "Edit uploaded photos",
  toViewSimplyTapUser:
    "To view, simply tap a picture. If you want to reorder just drag the photos. Alternatively, you can add more photos if you like.",
  city: "City",
  moreVenues: "More venues",
  allowNotifications: "Allow notifications",
  allowNotificationsMessage:
    "Allow notifications in your device settings so we can notify you of accessibility alerts in real-time",
  getAlerts: "Get Alerts",
  notNow: "Not now",
  allow: "Allow",
  notifyMe: "Notify me",
  iMInterestedInAccessibilityInformationForThisPlaceFor:
    "I'm interested in accessibility information for this place for",
  forMyself: "For myself",
  forSomeoneIKnow: "For someone I know",
  notifyMeAbout: "Notify me about",
  newAccessibilityInformation: "New accessibility information",
  liveAccessibilityAlerts: "Live accessibility alerts",
  alertsOn: "Alerts on",
  shareYourExperienceShort: "Share your experience",
  tellUsAboutYourExperienceHereAt: "Tell us about your experience here at",
  tellUsMoreAboutYourExperience: "Tell us more about your experience:",
  addAccessiblityTags: "Add accessibility tags",
  savedPlaces: "Saved places",
  uncoverMoreOnTheMap: "Uncover more on the map",
  createNewList: "Create new list",
  howWasThisPlaceAboutYourAccessibilityNeeds:
    "How was this place about your accessibility needs?",
  describeYourExperienceInMoreDetail: "Describe your experience in more detail",
  experiences: "Experiences",
  askAi: "Ask AI",
  askAiAboutThisVenue: "Ask AI about this venue",
  askAiTeaserSubtitle: "Accessibility, opening hours & more — just ask",
  askAiWelcome:
    "Hi! Ask me anything about this venue's accessibility, opening hours, or photos.",
  askAiPlaceholder: "Ask about this venue...",
  askAiDisclaimer:
    "AI can make mistakes. Check important details in the venue profile.",
  askAiError: "Sorry, I ran into a problem. Please try again.",
  askAiUnavailable:
    "The assistant is temporarily unavailable. Please try again shortly.",
  askAiOffline: "You appear to be offline. Reconnect to chat.",
  askAiRetry: "Retry",
  askAiShowDetails: "Show details",
  askAiStarterWheelchair: "Is it wheelchair accessible?",
  askAiStarterOpeningHours: "What are the opening hours?",
  askAiStarterSteps: "Are there steps at the entrance?",
  askAiStarterBathroom: "Is there an accessible bathroom?",
  askAiStarterOpenNow: "Is it open now?",
  askAiStarterAddInfo: "How can I add my experience?",
  askAiStarterGetNotified: "How do I get notified when info is added?",
  askAiStarterAddress: "What's the address?",
  send: "Send",
  clearChat: "Clear",
  wantMoreAccessibilityDetails: "Want more accessibility details?",
  clickToBeNotifiedWhenThisVenueHasAccessibilityInformationOrAlerts:
    "Click to be notified when this venue has accessibility information or alerts",
  reset: "Reset",
  searchAndFilter: "Search and filter",
  recentSearches: "Recent searches",
  more: "More",
  nearbyPlaces: "Nearby places",
  suggestedBySociability: "Suggested by Sociability",
  typesOfPlaces: "Types of places",
  selectTime: "Select time",
  saveYourSearch: "Save your search",
  saveYourSearchDescription: "Save your search to your saved searches list",
  loginToView: "Login to view",
  writeADescriptionOptional: "Write a description (optional)",
  shareThisVenue: "Share this venue",
  savedSearch: "Saved search",
  date: "Date",
  savedSearchDetails: "Saved search details",
  nameOfSavedSearch: "Name of saved search",
  searchKey: "Search key",
  editSavedSearch: "Edit saved search",
  areYouSureYouWantToDeleteThisSavedSearch:
    "Are you sure you want to delete this saved search?",
  savedSearchCreated: "Saved search created",
  savedSearchDeleted: "Saved search removed",
  savedSearchNameRequired: "Please enter a name for your saved search",
  savedSearchSaveFailed: "Failed to save search",
  noSearchResultsFoundText:
    "We couldn't find any places here. Try searching with different keywords or moving to another area.",
  gotIt: "Got it",
  accessibilityAlerts: "Accessibility alerts",
  viewDetails: "View details",
  hideDetails: "Hide details",
  backToAllResults: "Back to all results",
  moreAboutSociability: "More about Sociability",
  sociabilityWebsite: "Sociability website",
  contactUs: "Contact us",
  joinSociabilityCommunity: "Join Sociability community",
  downloadToMobile: "Download to mobile",
  // NearbySection labels
  viewAllOnMap: "View all on map",
  findVenuesIn: "Find venues in:",
  isSetAsDefault: "(Default)",
  lastUpdate: "Last update",
  viewMore: "View more",
  noVenuesFoundNearby: "No venues found nearby. Try adjusting your location.",
  removeFromSaved: "Remove from saved",
  saveVenue: "Save venue",
  scrollLeft: "Scroll left",
  scrollRight: "Scroll right",
  nearbyVenues: "Nearby venues",
  // HighlightsSection labels
  sociabilityHighlights: "Sociability Highlights",
  viewAll: "View all",
  // MoreInLocation labels
  moreIn: "More in",
  places: "places",
  // BrandsSection labels
  brands: "Brands",
  // ChangeLocationModal labels
  changeLocation: "Change location",
  noSuggestionsFound: "No suggestions found",
  reportNewAlert: "Report new alert",
  report: "Report",
  wantToReportSomethingElse: "Want to report something else?",
  shareYourExperienceInstead: "Share your experience instead.",
  shareExperience: "Share experience",
  noResolve: "No, resolve",
  updateLiveAlerts: "Update live alerts",
  unlockWhenNearby: "Unlock when you're nearby",
  mustBeAtVenueToAddNote:
    "Reporting is only available when you're near the venue. Move closer to report an alert and help keep accessibility information up to date.",
  allowLocationAccess: "Allow location access",
  allowLocationAccessMessage:
    "Allow location access in your device settings so we can confirm when you're near a venue.",
  // Search components labels
  newSearch: "New search",
  savedSearches: "Saved searches",
  searches: "Searches",
  filter: "Filter",
  openingHour: "Opening hour",
  searchOverlay: "Search",
  pressEnterToSearch: "Press Enter to search",
  seeLocations: "See locations",
  places: "Places",
  categoriesAndAreas: "Categories & areas",
  categoriesAndBrands: "Categories & brands",
  locations: "Locations",
  loadingPlace: "Loading place\u2026",
  accessibilityFilters: "Accessibility filters",
  searchAccessibilityFeatures: "Search accessibility features",
  searchAccessibilityOptions: "Search accessibility options",
  all: "All",
  businessTypes: "Business types",
  businessType: "Business type",
  noBusinessTypesAvailable: "No business types available",
  openingHoursFilter: "Opening hours filter",
  any: "Any",
  custom: "Custom",
  selectOpeningHoursMode: "Select opening hours mode",
  selectDay: "Select day",
  searchSuggestions: "Search suggestions",
  noRecentSearches: "No recent searches",
  noSavedSearchesYet: "No saved searches yet",
  startSearchingForPlacesDescription:
    "Start searching for places and save your searches for quick access later.",
  noSavedSearchesFoundMatching: "No saved searches found matching",
  placesSaved: "places saved",
  loadMore: "Load More",
  none: "None",
  neighborhood: "Neighborhood",
  noNeighborhoods: "No neighborhoods found",
  noNeighbourhoodSuggestionsAvailable: "No neighbourhood suggestions available",
  today: "Today",
  yesterday: "Yesterday",
  thisWeek: "This Week",
  lastWeek: "Last Week",
  thisMonth: "This Month",
  yourSearchHistoryWillAppearHere: "Your search history will appear here",
  scrollToLoadMore: "Scroll to load more",
  deleteSearch: "Delete search",
  viewMoreRecentSearches: "View more recent searches",
  viewMoreNeighborhoods: "View more neighborhoods",
  allRecentSearches: "All recent searches",
  allSuggestedBySociability: "All suggestions by Sociability",
  map: "Map",
  list: "List",
  notifications: "Notifications",
  allNotifications: "All notifications",
  liveAlerts: "Live alerts",
  newInformation: "New Information",
  unreadOnly: "Unread only",
  markAllAsRead: "Mark all as read",
  manageNotifications: "Manage notifications",
  searchNotifications: "Search notifications",
  noNotificationsToDisplay: "No notifications to display",
  allNotificationsMarkedAsRead: "All notifications marked as read",
  clearSearch: "Clear search",
  dayAgo: "day ago",
  daysAgo: "days ago",
  failedToMarkAllNotificationsAsRead:
    "Failed to mark all notifications as read",
  failedToMarkNotificationAsRead: "Failed to mark notification as read",
  hourAgo: "hour ago",
  hoursAgo: "hours ago",
  loadingMoreNotifications: "Loading more notifications",
  loadingNotifications: "Loading notifications",
  minuteAgo: "minute ago",
  minutesAgo: "minutes ago",
  notificationCategories: "Notification categories",
  notificationFound: "notification found",
  notificationList: "Notification list",
  notificationMarkedAsRead: "Notification marked as read",
  notificationOptions: "Notification options",
  notificationsFound: "notifications found",
  notificationsList: "Notifications list",
  showingAllNotifications: "Showing all notifications",
  showingUnreadNotificationsOnly: "Showing unread notifications only",
  unreadPrefix: "Unread: ",
  results: "Results",
  allVenues: "All venues",
  venuesWithData: "Venues with data",
  venuesWithoutData: "Venues without data",
  placesWithData: "Sociability Places",
  mapModeOverview: "Overview",
  mapModeExplore: "Explore",
  allPlaces: "All places",
  mapperView: "Mapper View",
  userView: "User View",
  noPlacesToDisplay: "No places to display",
  showOnlyPlacesWithoutData: "Show only places without data",
  backToAllNotifications: "Back to all notifications",
  willnotifyyouwhen: "We'll notify you when ",
  notifyme: "Notify me",
  yourPreferencesHaveBeenSaved: "Your preferences has been saved.",
  pushNotificationsNotAvailableOnWeb:
    "Push notifications aren't available on web yet — download the app to get live alerts.",
  searchPlaces: "Search places",
  showingLiveAlerts: "Showing live alerts",
  showingNewInformation: "Showing new information",
  notificationOptionsFor: "Notification options for",
  notificationFilters: "Notification filters",
  settingsCategories: "Settings categories",
  loadingNotificationSettings: "Loading notification settings",
  unlockInTheApp: "Unlock in the app",
  scanQrCodeToDownloadApp:
    "Scan QR code to download the Sociability mobile app",
  // AccessibilityInfoSection labels
  mappedPlacesNearYou: "Mapped places near you",
  beTheFirstToAddInfo: "Be the first to add info",
  beTheFirstToAddAccessibilityInfo: "Be the first to add accessibility info",
  showingNearestResults: "Showing nearest results",
  allActivity: "All activity",
  activityType: "Activity type",
  tag: "Tag",
  alerts: "Alerts",
  filterByDate: "Filter by date",
  informationHaveBeenUpdatedBySociabilityTeam:
    "Information have been updated by Sociability team",
  // Footer labels
  placesMapped: "Places mapped",
  photosUploaded: "Photos uploaded",
  communityMembers: "Community members",
  scanTheQRCodeToDownloadTheApp: "Scan the QR code to download the app",
  downloadOnAppStore: "Download on the App Store",
  getItOnGooglePlay: "Get it on Google Play",
  checkOutMore: "Check out more",
  signUpToOurNewsletter: "Sign up to our newsletter",
  visitSociabilityWebpage: "Visit Sociability Webpage",
  contactSales: "Contact Sales",
  connectWithUs: "Connect with us",
  letUsKnowHowWeCanImprove: "Let us know how we can improve by emailing at",
  followUsOnInstagram: "Follow us on Instagram",
  followUsOnFacebook: "Follow us on Facebook",
  followUsOnTikTok: "Follow us on TikTok",
  followUsOnLinkedIn: "Follow us on LinkedIn",
  // Activity date filter labels
  pastWeek: "Past week",
  pastMonth: "Past month",
  customDateRange: "Custom date range",
  // Activity item labels
  youSharedExperienceAt: "You shared a {experience} experience at",
  youSharedYourExperienceAt: "You shared your experience at",
  youAddedAccessibilityInfoAt: "You added accessibility information at",
  andOthers: "and {count} others",
  earlierThisMonth: "Earlier this month",
  earlier: "Earlier",
  noMoreResults: "You've reached the end",
  appliedFilters: "applied filters",
  // Activity page
  activityPageTitle: "Activity | Sociability",
  changeProfilePhoto: "Change profile photo",
  userEmailLabel: "User email: {email}",
  userStatistics: "User statistics",
  youReportedAnAlertAt: "You reported an alert at",
  youReportedANoteAt: "You reported a note at",
  anAlert: "an alert",
  aNote: "a note",
  youAddedAccessibilityInformationAt: "You added accessibility information at",
  activityFeed: "Activity feed",
  activityList: "Activity list",
  activityFilters: "Activity filters",
  searchActivities: "Search activities",
  filterActivitiesByDateRange: "Filter activities by date range",
  selectCustomDateRange: "Select custom date range",
  chooseDateRangeForActivityFilter: "Choose date range for activity filter",
  noUserActivityFound: "No user activity found",
  loadingMoreActivities: "Loading more activities",
  profileNavigation: "Profile navigation",
  filteredToActivities: "Filtered to {tabLabel} activities. {count} results.",
  showingActivitiesFor: "Showing {count} activities for {filterLabel}.",
  noActivitiesFound: "No activities found.",
  pastWeekLabel: "past week",
  pastMonthLabel: "past month",
  customDateRangeLabel: "custom date range",
  activityDateFormat: "MMMM d, yyyy'at' h:mm a",
  featuredArticle: "Featured article: {title}. Click to read more.",
  viewAllBlogPosts: "View all blog posts",
  // Search page labels
  searchResultsFor: "Search results for",
  searchResults: "Search results",
  scrollToTop: "Scroll to top",
  showMapView: "Show map view",
  showListView: "Show list view",
  viewingSavedSearch: "Viewing saved search",
  searchAlreadySaved: "Search already saved",
  openSearch: "Open search",
  backToHome: "Back to home",
  // Accessibility Detail View labels
  selectASpace: "Select a space",
  toggleSidebar: "Toggle sidebar",
  // General labels
  dismissAlert: "Dismiss alert",
  expandRadius: "Expand search radius",
  wantToVisit: "Want to visit",
  yourCuratedCollectionOfPlaces: "Your curated collection of places.",
  board: "Board",
  alphabetical: "Alphabetical",
  listDeleted: "List deleted",
  AccessibilityProfile: "Accessibility profile",
  notAvailableOnWeb:
    "aren't available on web yet — download the app to review them.",
  dateAddedNewestOldest: "Date added (Newest - Oldest)",
  dateAddedOldestNewest: "Date added (Oldest - Newest)",
  alphabeticalAZ: "Alphabetical (A-Z)",
  alphabeticalZA: "Alphabetical (Z-A)",
  resetToCurrentLocation: "Reset to current location",
  useCurrentLocation: "Use current location",
  loginForYourRecentSearch: "Log in for your recent search",
  cool: "Cool",
  beTheFirstToShare: "Be the first to share",
  usersSharedPositiveExperience: "users shared positive experience",
  user: "User",
  users: "Users",
  beTheFirstToReviewThisVenue: "Be the first to review this venue!",
  errorLoadingNotifications: "Error loading notifications. Please try again.",
  viewAllNotifications: "View all notifications",
  reports: "Reports",
  addAlert: "Add alert",
  viewLess: "View less",
  home: "Home",
  nearBySpaces: "Nearby spaces",
  neighbourhood: "Neighbourhood",
  logInToViewYourSavedSearches: "Log in to view your saved searches",
  seeAllYourSavedSearchesInOnePlaceAndReuseThemAnytime:
    "See all your saved searches in one place and reuse them anytime.",
  manageSavedSearches: "Manage saved searches",
  unsave: "Unsave",
  unsaved: "Unsaved",
  previousSpace: "Previous space",
  nextSpace: "Next space",
  pleaseLoginToViewYourNotifications: "Please login to view your notifications",
  stayUpToDateWithTheLatestAccessibilityUpdatesThatMatterToYouByLoggingIn:
    "Stay up to date with the latest accessibility updates that matter to you by logging in.",
  logInToViewYourSavedItems: "Log in to view your saved items",
  startSavingAndOrganisingYourFavouriteAccessibleSpotsByLoggingIn:
    "Start saving and organising your favourite accessible spots by logging in.",
  noNotificationsYet: "No notifications yet",
  youWillReceiveNotificationsForUpdatesFromYourSubscribedVenues:
    "You will receive notifications for updates from your subscribed venues.",
  saveASearchAfterViewingResultsThenReuseItAnytimeForQuickerSearching:
    "Save a search after viewing results, then reuse it anytime for quicker searching.",
  addTag: "Add tag",
  // AccessibilityMapView labels
  loadingMap: "Loading map...",
  // BrandsSection labels - additional
  items: "items",
  // ExploreOtherCities labels - additional
  discoverMappedPlaces:
    "Discover mapped places elsewhere, or add details to get this area started.",
  showNearestResults: "Show nearest results",
  exploreOtherCities: "Explore other cities",
  // NotificationPanel labels
  notification: "Notification",
  justNow: "Just now",
  // NotificationSettings labels
  selectNotificationCategory: "Select notification category",
  selectSettingsCategory: "Select settings category",
  appAccessibilitySettingsComingSoon: "App accessibility settings coming soon",
  devicePermissionSettingsComingSoon: "Device permission settings coming soon",
  // NotificationsPage labels
  markAsRead: "Mark as read",
  accessibilityAlert: "Accessibility alert",
  newAccessibilityInfo: "New accessibility information",
  // HighlightsSection labels
  blog: "Blog",
  // VenueDetailBasic labels
  address: "Address",
  website: "Website",
  phoneNumber: "Phone Number",
  getNotifications: "Get notifications",
  // VenueDetailComplex labels
  overview: "Overview",
  others: "Others",
  accessibilityGuide: "Accessibility guide",
  whatsNearby: "What's nearby",
  fullSite: "Full site",
  noAccessibilityFeaturesFound: "No accessibility features found",
  floorFilters: "Floor filters",
  searchFloorTypes: "Search floor types...",
  noFloorTypesFound: "No floor types found",
  showingResultsFor: "Showing results for",
  noMatchingSpacesFound: "No matching spaces found",
  noSpacesAvailable: "No spaces available",
  tryAdjustingSearchTerms:
    "Try adjusting your search terms or browse all categories.",
  noAccessibilitySpacesAvailable:
    "No accessibility spaces are currently available for this venue.",
  accessibilityTags: "accessibility tags",
  accessibilityTagsAvailable: "Accessibility tags available",
  viewGuideForAllSpaces: "View guide for all spaces",
  fromDiningToLeisure: "From dining to leisure, explore great places near",
  explorePlacesToVisitNear: "Explore places to visit near",
  public: "Public",
  floorNote: "Floor note",
  todoTask: "To-do task",
  projectInformation: "Project information",
  locationFilter: "Location filter",
  typeFilter: "Type filter",
  taskFilter: "Task filter",
  floorFilter: "Floor filter",
  searchReviews: "Search reviews",
  byLocation: "By location",
  noNotesFoundMatchingSearch: "No notes found matching your search.",
  noFloorNotesAvailable: "No floor notes available.",
  noTodoTasksAvailable: "No to-do tasks available.",
  noProjectInformationNotesAvailable: "No project information notes available.",
  noPublicNotesAvailable: "No public notes available.",
  generalTask: "General Task",
  general: "General",
  noImagesAvailable: "No images available",
  nearbyVenuesDesc:
    "with detailed accessibility information, making it easier to find what suits your needs.",
  dateAddedNewest: "Date added (Newest)",
  dateAddedOldest: "Date added (Oldest)",
  newest: "Newest",
  oldest: "Oldest",
  rating: "Rating",
  result: "result",
  menu: "Menu",
  // WhatsNearby labels
  distanceClosest: "Distance (Closest)",
  distanceFurthest: "Distance (Furthest)",
  sortColon: "Sort:",
  noNearbyVenuesFound: "No nearby venues found",
  noVenuesFound: "No venues found",
  loadingVenueDetails: "Loading venue details",
  noNearbyVenuesDataAvailable: "No nearby venues data available",
  mapOfNearbyVenues: "Map of Nearby Venues",
  accessibilityInformationDetails: "Accessibility information details",
  photosDetailView: "Photos detail view",
  venueSaved: "Venue saved",
  mapVisualDescription: "Map is visual. Use the results list to browse places.",
  addLiveAlert: "Add live alert",
  reportAlerts: "Report alerts",
  noAccessibilityInformationAvailableLongText:
    "Tap “Add venue photos” to upload photos or  tap “I want to know” to be notified when this venue has accessibility information or alerts",
  noAccessibilityInformationAvailableLongTextMapper:
    "Tap “Add tags” to tag accessibility features for this venue, or tap “Report alerts” to add mapper notes or flag accessibility issues.",
  addVenuePhotos: "Add venue photos",
  iWantToKnow: "I want to know",
  youllNowGetNotificationsForThisVenue:
    "You'll now get notifications for this venue",
  tapAddVenuePhotosToUploadPhotosOrTapManageNotificationsToUpdateYourPreferences:
    "Tap 'Add venue photos' to upload photos or tap 'Manage notifications' to update your preferences.",
  pushNotificationsArentAvailableOnWebYet:
    "Push notifications aren't available on web yet.",
  downloadTheAppToGetLiveAlerts: "Download the app to get live alerts.",
  tapAddVenuePhotosToUploadPhotosOrTapManageNotificationsToUpdateYourPreferences:
    "Tap 'Add venue photos' to upload photos or tap 'Manage notifications' to update your preferences.",
  noAlertsReportedYet: "No alerts reported yet",
  tapSubscribeForLiveAlertsToGetAccessibilityUpdates:
    "Tap “Subscribe for live alerts” to get accessibility updates.",
  subscribeForLiveAlerts: "Subscribe for live alerts",
  youllNowGetNotificationsForAlerts: "You'll now get notifications for alerts",
  tapManageNotificationsToManageYourNotificationsForThisVenue:
    "Tap 'Manage notifications' to manage your notifications for this venue",
  noPhotosForThisVenueYet: "No photos for this venue yet",
  tapAddPhotosToUploadVenuePhotos: "Tap “Add photos” to upload venue photos.",
  beTheFirstToShareYourExperience: "Be the first to share your experience",
  tapShareExperienceToHelpOthersBySharingYourAccessibilityExperience:
    "Tap “Share experience” to help others by sharing your accessibility experience.",
  noExperiencesAddedYet: "No experiences added yet",
  whenUsersAddExperienceForThisSiteYoullFindItHere:
    "When users add experience for this site, you'll find it here.",
  tapAddAlertsToBeTheFirstToShareAccessibilityInsights:
    "Tap Report alerts” to be the first to share accessibility insights!",
  tapAddTagsTpUploadVenuePhotos: "Tap “Add tags” to upload venue photos.",
  shareMyExperience: "Share my experience",
  stillTasting: "Still tasting",
  averageRatingWillAppearAfter3Experiences:
    "Average rating will appear after 3 experiences",
  sweet: "Sweet",
  sweetness: "Sweetness",
  sour: "Sour",
  experience: "experience",
  stillTastingSweetness: "Still tasting Sweetness",
  tapIWantToKnowToGetNotifiedWhenAccessibilityInformationOrAlertsAreAdded:
    "Tap “I want to know” to get notified when accessibility information or alerts are added",
  beTheFirstToKnow: "Be the first to know",
  applySavedSearches: "Apply saved searches",
  resetFilters: "Reset filters",
  // Venue Details Route - Main
  venueDetailsPageTitleSuffix: "Accessibility Info | Sociability",
  // SEO: appended after the truncated venue name, e.g. "The Blind Pig Accessibility | Sociability"
  venuePageTitleSuffix: "Accessibility | Sociability",
  // SEO meta description — split so the venue name can be interpolated in the middle
  venueMetaDescriptionPrefix: "Find detailed accessibility information for",
  venueMetaDescriptionSuffix:
    "on the Sociability app. View photos, entrance details, and step-free access info.",
  // Venue Details - Navigation & Tabs
  clickToBeNotifiedWhenThisVenueHas:
    "Click to be notified when this venue has accessibility information or alerts",
  iWantToKnow: "I want to know",
  // Venue Details - Accessibility Detail View
  searchLabel: "Search label",
  noSpacesFoundMatching: "No spaces found matching",
  noCategoryFound: "No category found",
  noAccessibilityTagsAvailable:
    "No accessibility tags available for this space",
  reportAnIssue: "Report an issue",
  closeSidebar: "Close sidebar",
  // Venue Details - Photos Detail View
  noCategoriesFoundMatching: "No categories found matching",
  photoCategories: "Photo categories",
  noPhotos: "No photos",
  photosPageTitleSuffix: "Photos | Sociability",
  // Venue Details - Interest Notification Modal
  gettingAlertsFor: "Getting alerts for",
  has: "has",
  pleaseSelectWhoYouAreGettingAlertsFor:
    "Please select who you're getting alerts for",
  // Venue Details - Venue Image With Actions
  venuePhotos: "Venue photos",
  // Venue Details - Accessibility Section
  accessibilityInfoPageTitleSuffix: "Accessibility Info | Sociability",
  accessibilityCategories: "Accessibility categories",
  accessibilityFeature: "Accessibility feature",
  noAdditionalAccessibilityInformationAvailable:
    "No additional accessibility information available",
  // Venue Details - Alerts/Notes
  alertsPageTitleSuffix: "Alerts | Sociability",
  alertsCategories: "Alerts categories",
  noAlertsOrNotesYet: "No alerts or notes yet",
  beTheFirstToAddInformationAboutThisVenue:
    "Be the first to add information about this venue",
  dateAddedNewest: "Date added (Newest)",
  dateAddedOldest: "Date added (Oldest)",
  venueArea: "Venue area",
  mapperActions: "Mapper actions",
  makeVenueNotVisibleToMappersUntil: "Make venue not visible to mappers until",
  on: "on",
  noEndDate: "No end date",
  flagNote: "Flag note",
  sociabilityTeam: "Sociability team",
  ongoing: "Ongoing",
  resolved: "Resolved",
  // Venue Details - Reviews/Experiences
  experiencesPageTitleSuffix: "Experiences | Sociability",
  sortExperiences: "Sort experiences",
  dateAddedFormat: "Date added",
  sharedA: "Shared a",
  moreOptions: "More options",
  less: "Less",
  reviewPhoto: "Review photo",
  reviewType: "Review type",
  photosOfReviews: "Photos of Reviews",
  // Venue Details - About Tab
  aboutPageTitleSuffix: "About | Sociability",
  sunday: "Sunday",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  pm: "PM",
  am: "AM",
  venueInformation: "Venue Information",
  open: "Open",
  closed: "Closed",
  toggleToViewFullOpeningHours: "Toggle to view full opening hours",
  hours: "Hours",
  // Flag/Report Components
  noteMustBeAtLeast5Characters: "Note must be at least 5 characters long",
  pleaseAddAtLeastOneImage: "Please add at least one image",
  charactersRequired: "Characters required",
  charactersRequiredFormat500:
    "/500 Characters - at least 5 characters required",
  charactersRequiredFormat150:
    "/150 Characters - at least 5 characters required",
  charactersRequiredFormat50: "/50 Characters - at least 5 characters required",
  charactersFormat500: "/500 Characters",
  charactersFormat150: "/150 Characters",
  charactersFormat50: "/50 Characters",
  closeModal: "Close modal",
  addPhotosAriaLabel: "Add photos",
  // Edit/Add Components
  pleaseSelectAnAreaFirst: "Please select an area first",
  noSuggestionsForThisArea: "No suggestions for this area",
  addManually: "Add manually",
  pleaseSelectYesForWholeVenue:
    "Please select 'Yes' for whole venue or choose a specific area to enable suggestions",
  newNoteHeadline: "New note headline",
  noEndDateSet: "No end date set",
  businessName: "Business name",
  claimSubmitted: "Claim submitted",
  pleaseSelectYourAccessibilityExperience:
    "Please select your accessibility experience (Sweet or Sour)",
  // Modal Components
  description: "Description",
  addedBy: "Added by",
  general: "General",
  noAccessibilityTagsAvailableForThisPhoto:
    "No accessibility tags available for this photo",
  pleaseSelectYourAccessibilityExperience:
    "Please select your accessibility experience (Sweet or Sour)",
  accessibilityInfo: "Accessibility info",
  imageAltText: "Image alt text",
  removedFrom: "Removed from",
  addedTo: "Added to",
  placeSaved: "place saved",
  // Accessibility Guide - Navigation & Actions
  venue: "Venue",
  backToFullAccessibilityGuide: "Back to full accessibility guide",
  searchSpacesByName: "Search spaces by name",
  // Accessibility Guide - Filters
  filterByAccessibilityFeatures: "Filter by accessibility features",
  clearAllAccessibilityFilters: "Clear all accessibility filters",
  filterByFloor: "Filter by floor",
  clearAllFloorFilters: "Clear all floor filters",
  // Accessibility Guide - Categories
  hideCategories: "Hide categories",
  showCategories: "Show categories",
  // Accessibility Guide - Images
  spacePreview: "space preview",
  defaultSpaceImage: "Default space image",
  viewAllImagesFor: "View all images for",
  // Accessibility Guide - Status & Messages
  noMatchingAccessibilityFeatures: "No matching accessibility features",
  noPhotosAvailableForSelectedFilter:
    "No photos available for the selected filter",
  noPhotosMatchSearch: "No photos match your search",
  searchPhotos: "Search photos...",
  // Accessibility Guide - Route & Page Titles
  accessibilityGuideTitleSuffix: "Accessibility Guide | Sociability",
  checkOutAccessibilityInfoAt: "Check out accessibility information at",
  // Accessibility Guide - Unknown/Fallback States
  unknownSpace: "Unknown Space",
  unknownCategory: "Unknown Category",
  unknown: "Unknown",
  // Accessibility Guide - Image Labels
  spaceImage: "Space image",
  imageWithoutAltText: "Image without alt text",
  viewFullSizeImage: "View full size image",
  // Accessibility Guide - Navigation
  skipNavigation: "Skip Navigation",
  nowShowing: "Now showing",
  // Accessibility Guide - Empty States
  noReviewsFound: "No reviews found!",
  noSpaceFound: "No {category} found",
  // Accessibility Guide - Actions & Labels
  shareAccessibilityInformation: "Share accessibility information",
  spaceInformation: "Space Information",
  searchBySpaceName: "Search by space name",
  // Note/Alert Actions
  dismissNote: "Dismiss note",
  dismissing: "Dismissing...",
  dismiss: "Dismiss",
  dismissNoteConfirm:
    "Are you sure you want to dismiss this note? This action cannot be undone.",
  // Complex Venue Tabs - Route & Content
  loadingVenueInformation: "Loading venue information",
  venueContent: "Venue content",
  contentNotFound: "Content Not Found",
  requestedContentNotFound: "The requested content could not be found.",
  backToVenue: "Back to Venue",
  noContentAvailable: "No content available",
  sectionNoContentToDisplay:
    "This section doesn't have any content to display yet.",
  weCounldntFindAMatch: "We couldn't find a match.",
  tryAdjustingYourFiltersOrStartANewSearch:
    "Try adjusting your filters or start a new search.",
  tapAddAlertsToBeTheFirstToShareAccessibilityInsights:
    "Tap “Add alerts” to be the first to share accessibility insights!",
  tapSubscribeForLiveAlertsToGetAccessibilityUpdates:
    "Tap “Subscribe for live alerts” to get accessibility updates.",
  youllNowGetNotificationsForAlerts: "You'll now get notifications for alerts",
  tapManageNotificationsToUpdateYourPreferences:
    "Tap “Manage notifications” to update your preferences.",
  getNotifiedAboutNewOrUpdatedLiveAlertsForThisVenue:
    "Get notified about new or updated live alerts for this venue",
  noThanks: "No, thanks",
  searchAlerts: "Search alerts",
  getStartedWithSociability: "Get started with Sociability!",
  enterYourEmailToCreateYourAccount: "Enter your email to create your account",
  yourWorkEmail: "Your work email",
  continueWithEmail: "Continue with email",
  or: "or",
  checkingEmail: "Checking email...",
  generatingOTP: "Generating OTP...",
  welcomeBack: "Welcome back",
  dontHaveAnAccount: "Don't have an account?",
  signUp: "Sign Up",
  weveEmailedYouACode: "We've emailed you a code",
  enterTheOneTimePasscodeEmailedTo: "Enter the one-time passcode emailed to",
  toCompleteYourAccountSetUp: "to complete your account set-up.",
  enterOneTimePasscode: "Enter one-time passcode",
  verifyCode: "Verify code",
  didntReceiveTheCode: "Didn't receive the code?",
  resendCode: "Resend code",
  rememberYourPassword: "Remember your password?",
  resettingPassword: "Resetting password...",
  itsOkayEnterYourWorkEmailAddressAndWeWillEmailToResetYourPassword:
    "Enter your work email address and we'll email to reset your password.",
  checkYourEmail: "Check your email",
  returnToLogin: "Return to login",
  bearInMindThatThisWillBeValidFor30MinutesOnly:
    "Bear in mind that this will be valid for 30 minutes only",
  ifYouHaveASociabilityAccountWeveSentAnEmailTo:
    "If you have a Sociability account, we've sent an email to",
  withALinkThatYouCanUseToResetYourPassword:
    "with a link that you can use to reset your password. If you don't see this email with in few minutes, check your spam folder.",
  createYourAccount: "Create your account",
  setANameAndPasswordForYourSociabilityAccount:
    "Set a name and password for your Sociability account.",
  addYourJobTitleAndFunctionToHelpUsPersonaliseYourExperience:
    "Add your job title and function to help us personalise your experience.",
  confirmNewPassword: "Confirm new password",
  savePassword: "Save password",
  youveBeenAddedToSociability: "You've been added to Sociability",
  hasInvitedYouToJoinSociability:
    "has invited you to join Sociability. Set a password to access your account",
  setYourPassword: "Set your password",
  howWouldYouRateYourExperience: "How would you rate your experience?",
  yourFeedback: "Your feedback",
  tellUsWhatYouThink: "Tell us what you think...",
  pleaseEnterAtLeast5Characters: "Please enter at least 5 characters",
  cancel: "Cancel",
  submitFeedback: "Submit feedback",
  helpUsImproveTheBusinessPortal: "Help us improve the Business Portal",
  leaveFeedback: "Leave feedback",
  letsGetYouStarted: "Let's get you started",
  getStartedWithSociabilityByCompletingTheFollowingTasks:
    "Get started with Sociability by completing the following tasks",
  watch2MinDemo: "Watch 2 min demo",
  thatsAllForYourNotifications:
    "That's all for your notifications over the past 30 days",
  siteList: "Site list",
  siteInformationViewSociability: "Sociability",
  siteInformationQrCode: "QR code",
  siteInformationTabFlags: "Flags",
  siteInformationTabCustomView: "Guides",
  siteInformationTabCms: "CMS",
  siteInformationTabMedia: "Media",
  siteInformationTabPlaceholder:
    "This section will be available in a future update.",
  siteInformationAccessibilityEmptyHint:
    'Tap "Add accessibility" to upload information about the venue',
  siteInformationAddAccessibility: "Add accessibility",
  remindMeLater: "Remind me later",
  completeYourProfile: "Complete your profile",
  pleaseSelectAFunction: "Please select a function",
  skip: "Skip",
  tellUsYourJobFunction: "Tell us your job function",
  jobDescriptionRequiredWhenOther:
    "Please describe your role when you select Other.",
  supportHeadline: "We're here to help",
  supportSubheadline:
    "Talk to a member of our support team, ask questions, or find guidance about how to use our Business Portal",
  yourCustomerSuccessTeam: "Your customer success team",
  customerSuccessOfficer: "Customer Success Officer",
  getInTouch: "Get in touch",
  sendAnEmail: "Send an email",
  sendAnEmailDescription:
    "Contact our Customer Success team directly for personalised support",
  bookACall: "Book a call",
  bookACallDescription:
    "Book a call directly with our Customer Success team for in depth support.",
  helpAndGuidance: "Help and guidance",
  helpAndGuidanceDescription:
    "Read articles in our Knowledge Base to learn more about using your Business Portal",
  viewVenue: "View Venue",
  venueInfo: "Venue info",
  reviewVenueDetailsOnWeb: "Review venue details on web",
  addLiveAlertsInApp: "Add live alerts in app",
  manageVenue: "Manage Venue",
  submitAlert: "Submit alert",
  lowercaseAlerts: "alerts",
  // ── CMS (Business Area Tabs) ────────────────────────────────────
  cmsSearchPlaceholder: "Search content",
  cmsSearchAriaLabel: "Search CMS content",
  cmsAddContent: "Add content",
  cmsReorder: "Reorder",
  cmsLive: "Live",
  cmsInactive: "Inactive",
  cmsSortBy: "Sort by",
  cmsSortRecentlyUpdated: "Recently updated",
  cmsSortRecentlyCreated: "Recently created",
  cmsSortTitleAsc: "Title (A → Z)",
  cmsSortTitleDesc: "Title (Z → A)",
  cmsResultsSingular: "Result",
  cmsResultsPlural: "Results",
  cmsLastUpdate: "Last update",
  cmsEditAction: "Edit",
  cmsPreviewAction: "Preview",
  cmsEmptyTitle: "No content yet",
  cmsEmptyDescription: "When you add content for this site, it'll appear here.",
  cmsFilteredEmptyTitle: "No content matches these filters",
  cmsFilteredEmptyDescription:
    "Try clearing the search or status filter to see more.",
  cmsContentListBack: "Content list",
  cmsTabContent: "Content",
  cmsTabSettings: "Settings",
  cmsUntitled: "Untitled",
  cmsCancel: "Cancel",
  cmsSave: "Save",
  cmsUnsavedChanges: "Unsaved changes",
  cmsContentDetails: "Content details",
  cmsTitleLabel: "Title",
  cmsSubtitleLabel: "Subtitle",
  cmsDescriptionLabel: "Describe what visitors will find on this page",
  cmsCoverPhoto: "Cover photo",
  cmsCoverPhotoAltLabel: "Cover photo alt text",
  cmsCoverPhotoAltGenerate: "Generate",
  cmsCoverPhotoAltRegenerate: "Regenerate",
  cmsCoverPhotoAltUndo: "Undo",
  cmsCoverPhotoAltUndoAria: "Undo AI-generated description",
  cmsCoverPhotoRemove: "Remove",
  cmsCoverPhotoRecommendation: "Recommended: 600 × 400px, JPG/PNG",
  cmsCoverPhotoDrop: "Drag files here or",
  cmsCoverPhotoBrowse: "browse",
  cmsReplacePhoto: "Replace",
  cmsRegenerate: "Regenerate",
  cmsDeleteContent: "Delete content",
  cmsDeleteConfirmTitle: "Delete content?",
  cmsDeleteConfirmBody:
    "This will permanently remove the content and any uploaded images. This action cannot be undone.",
  cmsDiscardConfirmTitle: "Discard changes?",
  cmsDiscardConfirmBody:
    "You have unsaved changes. If you leave now they will be lost.",
  cmsDiscardConfirmKeepEditing: "Keep editing",
  cmsDiscardConfirmDiscard: "Discard changes",
  cmsPageContent: "Page content",
  cmsPageContentHint:
    "Use the toolbar to format your content. Save when you're done.",
  cmsPageContentSlashHint:
    "Type / in the editor to insert blocks like headings, lists and images.",
  cmsPageContentEmpty: "No content added yet",
  cmsPageContentEmptyHint: 'Type "/" for commands',
  cmsSlashText: "Text",
  cmsSlashTextHint: "Plain paragraph text",
  cmsSlashHeading1: "Heading 1",
  cmsSlashHeading2: "Heading 2",
  cmsSlashHeading3: "Heading 3",
  cmsSlashHeading4: "Heading 4",
  cmsSlashBulletList: "Bulleted list",
  cmsSlashOrderedList: "Numbered list",
  cmsSlashQuote: "Quote",
  cmsSlashCode: "Code block",
  cmsSlashImage: "Image",
  cmsSlashImageHint: "Upload or drop an image inline",
  cmsSlashMenuNoResults: "No matching blocks",
  cmsBlockInsertBelow: "Insert block below",
  cmsImageBlockDropPrefix: "Drag files here or",
  cmsImageBlockBrowse: "browse",
  cmsImageBlockConstraints: "JPG or PNG, up to {max}",
  cmsImageBlockInvalidType: "Please choose a JPG or PNG image.",
  cmsImageBlockTooLarge: "Image is too large. Maximum size is {max}.",
  cmsImageBlockAltLabel: "Image alt text",
  cmsImageBlockAltPlaceholder:
    "Describe the image for people using screen readers",
  cmsImageBlockAltRequired: "Alt text is required for every image.",
  cmsImageBlockDelete: "Delete image",
  cmsImageBlockReplace: "Replace",
  cmsImageBlockDragHandle: "Drag to move image",
  cmsImageBlockAiNoAuth: "Sign in is required to generate a description.",
  cmsImageBlockAiFailed: "Failed to generate description.",
  cmsImageBlockAlignLeft: "Align left",
  cmsImageBlockAlignCenter: "Align centre",
  cmsImageBlockAlignRight: "Align right",
  cmsImageBlockSizeSmall: "Small",
  cmsImageBlockSizeMedium: "Medium",
  cmsImageBlockSizeLarge: "Large (full width)",
  cmsImageBlockAltEdit: "Edit alt text",
  cmsImageBlockAltDialogTitle: "Image description",
  cmsImageBlockAltDialogHint:
    "Describe the image for people using screen readers. You can write it yourself or generate one with AI.",
  cmsImageBlockAltSave: "Save description",
  cmsImageBlockAltCancel: "Cancel",
  cmsImageBlockAltGenerateAi: "Generate with AI",
  cmsImageBlockAltMissingBadge: "Alt text missing",
  cmsImagesCurrentTitle: "Current Images",
  cmsImagesCurrentEmpty: "No images attached yet.",
  cmsImagesReorderHint:
    "Drag and drop images using the grip handle to reorder them. Changes will be saved automatically.",
  cmsImagesOrderLabel: "Order:",
  cmsImagesEdit: "Edit",
  cmsImagesDelete: "Delete",
  cmsImagesDragHandle: "Drag to reorder image",
  cmsImagesAddTitle: "Add New Images",
  cmsImagesAddHint:
    "You can add multiple new images to this tab. These will be displayed in the order specified.",
  cmsImagesAddFileLabel: "Tab Image",
  cmsImagesAddAltLabel: "Image Alt-Text",
  cmsImagesAddAltPlaceholder:
    "Describe the image for people using screen readers",
  cmsImagesAddOrderLabel: "Order",
  cmsImagesAddBrowse: "Choose File",
  cmsImagesAddReplace: "Replace",
  cmsImagesAddPreviewAlt: "Selected image preview",
  cmsImagesAddNoFile: "No file chosen",
  cmsImagesAddMore: "Add More",
  cmsImagesAddRemoveRow: "Remove image row",
  cmsImageReordered: "Image order updated.",
  cmsImageDeleted: "Image deleted.",
  cmsImageDeleteConfirmTitle: "Delete image?",
  cmsImageDeleteConfirmBody:
    "This will permanently remove the image from this tab. This action cannot be undone.",
  cmsImageDeleteConfirm: "Delete image",
  cmsImageEditTitle: "Edit Image",
  cmsImageEditAltLabel: "Alt Text",
  cmsImageEditOrderLabel: "Order",
  cmsImageEditPreviewLabel: "Image Preview",
  cmsImageEditSave: "Save changes",
  cmsImageEditSaved: "Image updated.",
  cmsBlocksPanelTitle: "Page content",
  cmsBlocksPanelHint:
    "Add one or more blocks to build this content page. Save the tab when you are done.",
  cmsBlocksEmptyTitle: "No content added yet",
  cmsBlocksEmptyHint:
    "Tap the button above to start building your content page.",
  cmsBlocksInsertBlock: "Insert block",
  cmsBlocksUntitledBlock: "Untitled block",
  cmsBlocksImagesLabel: "image",
  cmsBlocksImagesLabelPlural: "images",
  cmsBlocksReorderHint:
    "Drag and drop blocks using the grip handle to reorder them. Changes are saved automatically.",
  cmsBlocksDragHandle: "Drag to reorder block",
  cmsBlocksEditAction: "Edit",
  cmsBlocksDeleteAction: "Delete block",
  cmsBlocksDeleteConfirmTitle: 'Delete "{title}"?',
  cmsBlocksDeleteConfirmBody:
    "This will permanently remove the block and any uploaded images. This action cannot be undone.",
  cmsBlocksDeleted: "Block deleted.",
  cmsBlocksReordered: "Block order updated.",
  cmsBlocksMoreActions: "Block actions",
  cmsBlocksMarkAsLive: "Mark as live",
  cmsBlocksMarkAsInactive: "Mark as inactive",
  cmsBlocksExpand: "Expand block",
  cmsBlocksCollapse: "Collapse block",
  cmsBlockDialogNewTitle: "New block",
  cmsBlockDialogEditTitle: "Edit block",
  cmsBlockBackToTab: "Back to content",
  cmsBlockTitleLabel: "Block title",
  cmsBlockTitleRequired: "Block title is required.",
  cmsBlockStatusLabel: "Status",
  cmsBlockStatusHint:
    "Active blocks are visible to visitors. Inactive blocks stay as admin drafts.",
  cmsBlockOrderLabel: "Order",
  cmsBlockContentLabel: "Content",
  cmsBlockContentHint:
    "Use the toolbar to format the block content. Inline images live in this block's gallery.",
  cmsBlockImagesTitle: "Block images",
  cmsBlockImagesHint:
    "Upload images for this block. You can also insert them inside the content via the Upload image toolbar button.",
  cmsBlockImagesEmpty: "No images uploaded yet.",
  cmsBlockImagesAdd: "Add image",
  cmsBlockImageInUseError:
    "Remove the image from the editor first, then delete it.",
  cmsBlockSave: "Save block",
  cmsBlockCancel: "Cancel",
  cmsBlockDiscardConfirmTitle: "Discard block changes?",
  cmsBlockDiscardConfirmBody:
    "Your unsaved field edits will be lost. Uploaded images stay attached to the block.",
  rteCancel: "Cancel",
  rteInsert: "Insert",
  rteToolbarLabel: "Text formatting",
  rteToolbarUndo: "Undo",
  rteToolbarRedo: "Redo",
  rteToolbarHeading: "Text style",
  rteToolbarParagraph: "Paragraph",
  rteToolbarHeading1: "Heading 1",
  rteToolbarHeading2: "Heading 2",
  rteToolbarHeading3: "Heading 3",
  rteToolbarHeading4: "Heading 4",
  rteToolbarFontSize: "Font size",
  rteToolbarHighlight: "Highlight",
  rteToolbarHighlightReset: "Remove highlight",
  rteToolbarBold: "Bold",
  rteToolbarItalic: "Italic",
  rteToolbarUnderline: "Underline",
  rteToolbarStrike: "Strikethrough",
  rteToolbarBulletList: "Bulleted list",
  rteToolbarOrderedList: "Numbered list",
  rteToolbarAlignLeft: "Align left",
  rteToolbarAlignCenter: "Align center",
  rteToolbarAlignRight: "Align right",
  rteToolbarAlignJustify: "Justify",
  rteToolbarTextColor: "Text colour",
  rteToolbarTextColorCustom: "Custom",
  rteToolbarTextColorReset: "Reset",
  rteToolbarLink: "Insert link",
  rteToolbarImage: "Insert image",
  rteToolbarImageUpload: "Upload image",
  rteToolbarBlockquote: "Blockquote",
  rteToolbarCode: "Inline code",
  rteToolbarCodeBlock: "Code block",
  rteLinkInsertTitle: "Insert link",
  rteLinkUrlLabel: "URL",
  rteImagePickerTitle: "Insert image from tab gallery",
  rteImagePickerEmpty:
    "No images available yet. Add images to this tab and save to use them here.",
  rteImagePickerInsertOne: "Insert image",
  cmsSociabilityVisibility: "Sociability visibility",
  cmsSociabilityVisibilityHint: "Make this content public",
  cmsReorderTitle: "Reorder content",
  cmsReorderHint:
    "The order set here determines how contents are ordered on your guide",
  cmsReorderDragHandle: "Drag to reorder",
  cmsReorderSave: "Save",
  cmsReorderCancel: "Cancel",
  cmsValidationTitleRequired: "Please enter a title.",
  cmsValidationTitleMax: "Title must be 50 characters or less.",
  cmsValidationSubtitleMax: "Subtitle must be 50 characters or less.",
  cmsErrorLoadList: "Could not load CMS content. Please try again.",
  cmsErrorLoadTab: "Could not load this content. Please try again.",
  cmsSuccessCreated: "Content created.",
  cmsSuccessUpdated: "Content saved.",
  cmsSuccessDeleted: "Content deleted.",
  cmsSuccessReordered: "Content order updated.",
  beTheFirstToShareYourExperience: "Be the first to share your experience",
  findPlacesOnMap: "Find places on map",
  addAccessibilityInformationToYourLocalVenues:
    "Add accessibility information for your local venues",
  beTheFirstToShareAccessibilityInformation:
    "Be the first to share accessibility information or find places nearby to subscribe for updates",
};

const es = {
  appName: "Socialbility",
  welcome: "Hola",
};

const ja = {
  appName: "Socialbility",
  welcome: "Konnichiwa",
};

const de = {
  appName: "Socialbility",
  welcome: "Hallo",
};

export { en, es, ja, de };
